import training from './training'
import exam from './exam'

const sbs = {
  path: 'sbs_portal',
  component: resolve => require(['../../../pages/portal/sbs'], resolve),
  children: [
    training,
    exam
  ]
}

export default sbs
